import { render } from "./OptRegionBarChart.vue?vue&type=template&id=965938a6"
import script from "./OptRegionBarChart.vue?vue&type=script&lang=js"
export * from "./OptRegionBarChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__